import { RefObject, useEffect } from "react";

/** Calls onDismiss on a click outside `ref` or on Escape, while `isOpen` (popovers and dropdowns). */
function useDismiss(
  // React 19's useRef<HTMLDivElement>(null) is a RefObject<HTMLDivElement | null>.
  ref: RefObject<HTMLElement | null>,
  isOpen: boolean,
  onDismiss: () => void
) {
  useEffect(() => {
    if (!isOpen) {
      return;
    }

    const dismissOnOutsideClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onDismiss();
      }
    };
    const dismissOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onDismiss();
      }
    };

    document.addEventListener("mousedown", dismissOnOutsideClick);
    document.addEventListener("keydown", dismissOnEscape);
    return () => {
      document.removeEventListener("mousedown", dismissOnOutsideClick);
      document.removeEventListener("keydown", dismissOnEscape);
    };
  }, [ref, isOpen, onDismiss]);
}

export default useDismiss;
